import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { IconButton, ListItem, ListItemText } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const FileUploaded = ({ title, link, onPressDelete, disabled }) => {
  const theme = useTheme();

  return (
    <ListItem
      style={{
        background: "#F2F4F6",
        marginTop: "2rem",
        padding: "1rem",
        borderRadius: "0.3rem",
      }}
      secondaryAction={
        disabled ? null : (
          <IconButton aria-label="delete" onClick={onPressDelete}>
            <DeleteOutlinedIcon sx={{ color: theme.palette.error.main }} />
          </IconButton>
        )
      }
    >
      <a href={link} target="_blank">
        {title}
      </a>
    </ListItem>
  );
};

export default FileUploaded;
